<ng-container>
  <div id="candidate_filter_scroll_left_button" (click)="scrollLeft()" (mouseenter)="onMouseEnter1()" (mouseleave)="onMouseLeave1()"
    class="filter-show-hidden-design-left">
    <div class="left-scroll-buttons">
      <div>
        <ng-icon name="tablerChevronLeft"></ng-icon>
      </div>
    </div>
  </div>
  <div class="header-filters-container" [formGroup]="candidateFilterForm" id="scrollContainer">

    <!-- publishedBy , customer and  businessCustomer is commented for now  -->

    <!-- <div class="dropdown-filter-input-container" [ngClass]="{'reduce-mr-rt': publishedByCount > 0}">
      <input placeholder="Published by" type="text" class="form-control input-sm-1 dropdown-filter-input filter-selected-form-control"
        yPosition="below" xPosition="after" [matMenuTriggerFor]="menu0" id="publishedByContent" #experienceType
        [ngClass]="{'filter-selected-form-control': publishedByCount > 0}"
        formControlName="publishedByContent" readonly style="width: fit-content;">
      <span *ngIf="publishedByCount == 0" class="dropdown-filter-input-svg" [matMenuTriggerFor]="menu0">
        <ng-icon name="tablerChevronDown"></ng-icon>
      </span>
      <span *ngIf="publishedByCount > 0" class="dropdown-filter-input-svg" [matMenuTriggerFor]="menu0">
        <ng-icon name="tablerChevronDown"></ng-icon>
      </span>
      <span *ngIf="publishedByCount > 0" class="filter-count-ticker" [matMenuTriggerFor]="menu0">
        {{publishedByCount}}
      </span>
    </div>
    <mat-menu #menu0="matMenu">

      <div style="border: none !important;" (click)="$event.stopPropagation();">
        <div class="col-sm-12 p-0">
          <div class="filter-title">
            <span style="padding-left: 1rem;"><b> Published By </b></span>
          </div>

          <div class="col-sm-12 p-0" >
            <app-customer-filter-template
              [filterData]="publishedByList | async"
              [asyncSearch]="true"
              [title]="'Published By'"
              [resetFilter]="candidateFilterForm.get('resetFilter').value"
              [this]="this"
              [isLoading]="isLoading"
              [filterKey]="'fullName'"
              [withAccordion]="false"
              (onSearch)="onPublishSearch($event)"
              (onSelect)="onSelectChange($event , 'selectedPublishedBy')"
              (onScroll)="onPublishScroll($event)"
             >
            </app-customer-filter-template>
          </div>
          <app-common-skeleton   *ngIf="isLoading"  [NameOftheScreen]="'CheckboxSelection'"></app-common-skeleton>

        </div>
      </div>

    </mat-menu> -->

    <!-- <div class="dropdown-filter-input-container" [ngClass]="{'reduce-mr-rt': customerCount > 0}" *ngIf=" businessNetworkData?.length > 0">
      <input placeholder="Customer" type="text" class="form-control input-sm dropdown-filter-input add-postedDayRange-ticker-padding filter-selected-form-control"
        yPosition="below" xPosition="after" [matMenuTriggerFor]="menu1" #postedDayRange formControlName="customerContent"
        [ngClass]="{'filter-selected-form-control': customerCount > 0, 'ticker-space-added': customerCount > 0}"
        readonly id="customerContent">
        <span *ngIf="customerCount == 0" class="dropdown-filter-input-svg" [matMenuTriggerFor]="menu1">
          <ng-icon name="tablerChevronDown"></ng-icon>
        </span>
        <span *ngIf="customerCount > 0" class="dropdown-filter-input-svg" [matMenuTriggerFor]="menu1">
          <ng-icon name="tablerChevronDown"></ng-icon>
        </span>
        <span *ngIf="customerCount > 0" class="filter-count-ticker" [matMenuTriggerFor]="menu1">
          {{customerCount}}
        </span>
    </div>
    <mat-menu  #menu1="matMenu">

        <div style="border: none !important;" (click)="$event.stopPropagation();">
          <div class="col-sm-12 p-0">
            <div class="filter-title">
              <span style="padding-left: 1rem;"><b> Customer </b></span>
            </div>

            <div class="col-sm-12 p-0" >
              <app-customer-filter-template
                [filterData]="customersList | async"
                [asyncSearch]="true"
                [this]="this"
                [title]="'Customer'"
                [resetFilter]="candidateFilterForm.get('resetFilter').value"
                [isLoading]="isLoading"
                [filterKey]="'businessName'"
                [withAccordion]="false"
                (onSearch)="onCustomerSearch($event)"
                (onSelect)="onSelectChange($event , 'selectedCustomers')"
                (onScroll)="onCustomerScroll($event)"
                >
              </app-customer-filter-template>
            </div>
            <app-common-skeleton   *ngIf="isLoading"  [NameOftheScreen]="'CheckboxSelection'"></app-common-skeleton>
          </div>
        </div>
    </mat-menu> -->

    <!-- <div class="dropdown-filter-input-container"  [ngClass]="{'reduce-mr-rt': busienssNetworkCount > 0}"
      *ngIf="jobSourcesFormarray.at(0) != undefined &&  jobSourcesFormarray.at(0).get('businessNetwork').value && businessNetworkData?.length > 0">
      <input placeholder="Customer" type="text" class="form-control input-sm dropdown-filter-input  filter-selected-form-control"
        yPosition="below" xPosition="after" [matMenuTriggerFor]="menu7" formControlName="businessNetworkContent"
        [ngClass]="{'filter-selected-form-control': busienssNetworkCount > 0}"
        readonly id="businessNetworkContent" style="width: fit-content;">
        <span *ngIf="busienssNetworkCount == 0" class="dropdown-filter-input-svg" [matMenuTriggerFor]="menu7">
          <ng-icon name="tablerChevronDown"></ng-icon>
        </span>
        <span *ngIf="busienssNetworkCount > 0" class="dropdown-filter-input-svg" [matMenuTriggerFor]="menu7">
          <ng-icon name="tablerChevronDown"></ng-icon>
        </span>
        <span *ngIf="busienssNetworkCount > 0" class="filter-count-ticker" [matMenuTriggerFor]="menu7">
          {{busienssNetworkCount}}
        </span>
    </div>
    <mat-menu  #menu7="matMenu">

        <div class="content-container-mini-loader"  style="border: none !important;">
          <div class="col-sm-12 p-0 form-group">
            <div class="filter-title">
              <span style="padding-left: 1rem;"><b> Business Networks </b></span>
            </div>

            <div class="col-sm-12 p-0" (click)="$event.stopPropagation();">
              <app-customer-filter-template
              [title]="'Business Networks'"
              [filterData]="businessNetworkData"
              [filterKey]="'b2bNetworkName'"
              [this]="this"
              [resetFilter]="candidateFilterForm.get('resetFilter').value"
              [withAccordion]="false"
              [showFilter]="true"
              (onSelect)="onSelectChange($event , 'selectedBusinessNetworks' , this)"
              >
              </app-customer-filter-template>
            </div>
            <app-common-skeleton   *ngIf="isLoading"  [NameOftheScreen]="'CheckboxSelection'"></app-common-skeleton>
          </div>
        </div>
    </mat-menu> -->


    <div class="dropdown-filter-input-container reduce-mr-rt">
      <input placeholder="Posted (Days)" type="text"
        class="form-control input-sm-1 dropdown-filter-input add-postedDayRange-ticker-padding filter-selected-form-control"
        yPosition="below" xPosition="after" [matMenuTriggerFor]="menu1" #postedDayRange formControlName="postedDayRangeContent"
        readonly id="postedDayRange">
      <span class="dropdown-filter-input-svg" [matMenuTriggerFor]="menu1">
        <ng-icon name="tablerChevronDown"></ng-icon>
      </span>
      <span class="filter-count-ticker" [matMenuTriggerFor]="menu1">
        1
      </span>
    </div>
    <mat-menu [class]="'filter-body w-fit p-0'" #menu1="matMenu" >
        <div class="checkboxclassRadio" (click)="$event.stopPropagation();">
          <div class="col-sm-12 border-none" [ngClass]="{'disabled': filterApplied==true}">
            <div class="filter-title form-group" style="margin-bottom: 0;">
              <span class="card-header- tab-title custom-text"><b> Posted (Days)</b></span>
            </div>
            <div class="custom-form-check">
              <input class="form-check-input" formControlName="postedDayRange"
                [value]="POSTED_ANY" style="display: none;" type="radio" id="exampleRadio00">
              <label class="form-check-label custom-radio-label custom-text " for="exampleRadio00" (click)="onPostedDaysChange(POSTED_ANY)">
                {{POSTED_ANY}}
              </label>
            </div>
            <div class="custom-form-check">
              <input class="form-check-input" formControlName="postedDayRange"
                [value]="POSTED_TODAY" style="display: none;" type="radio" id="exampleRadio11">
              <label class="form-check-label custom-radio-label custom-text " for="exampleRadio11" (click)="onPostedDaysChange(POSTED_TODAY)">
                {{POSTED_TODAY}}
              </label>
            </div>
            <div class="custom-form-check">
              <input class="form-check-input" formControlName="postedDayRange"
                [value]="POSTED_LAST_7_DAYS" style="display: none;" type="radio" id="exampleRadio44">
              <label class="form-check-label custom-radio-label custom-text " for="exampleRadio44" (click)="onPostedDaysChange(POSTED_LAST_7_DAYS)">
                {{POSTED_LAST_7_DAYS}}
              </label>
            </div>
            <div class="custom-form-check">
              <input class="form-check-input" formControlName="postedDayRange"
                [value]="POSTED_LAST_14_DAYS" style="display: none;" type="radio" id="exampleRadio22">
              <label class="form-check-label custom-radio-label custom-text " for="exampleRadio22" (click)="onPostedDaysChange(POSTED_LAST_14_DAYS)">
                {{POSTED_LAST_14_DAYS}}
              </label>
            </div>
            <div class="custom-form-check">
              <input class="form-check-input" formControlName="postedDayRange"
                [value]="POSTED_LAST_30_DAYS" style="display: none;" type="radio" id="exampleRadio33">
              <label class="form-check-label custom-radio-label custom-text " for="exampleRadio33" (click)="onPostedDaysChange(POSTED_LAST_30_DAYS)">
                {{POSTED_LAST_30_DAYS}}
              </label>
            </div>
          </div>
        </div>
        <div *ngIf="isLoading" class="load-overlay-filter" (click)="$event.stopPropagation();">
          <app-common-skeleton  [NameOftheScreen]="'CheckboxSelection'"></app-common-skeleton>
        </div>
    </mat-menu>

    <div class="dropdown-filter-input-container reduce-mr-rt" [matMenuTriggerFor]="menu2">
      <input placeholder="Experience (Years)" type="text"
        class="form-control input-sm-1 dropdown-filter-input add-experienceType-ticker-padding filter-selected-form-control"
        yPosition="below" xPosition="after" id="experienceType" #experienceType
        formControlName="experienceTypeContent" readonly>
      <span class="dropdown-filter-input-svg">
        <ng-icon name="tablerChevronDown"></ng-icon>
      </span>
      <span class="filter-count-ticker">
        1
      </span>
    </div>
    <mat-menu #menu2="matMenu" [class]="'filter-body w-fit p-0'">
        <div class="checkboxclassRadio" (click)="$event.stopPropagation();">
          <div class="col-sm-12 border-none" [ngClass]="{'disabled': filterApplied==true}">
            <div class="filter-title form-group"  style="margin-bottom: 0;">
              <span class="card-header- tab-title custom-text"><b> Experience (Years)</b></span>
            </div>
            <div class="custom-form-check">
              <input class="form-check-input" formControlName="experienceType"
                [value]="EXPERIENCE_ANY" style="display: none;" type="radio" id="exampleRadio0">
              <label class="form-check-label custom-radio-label custom-text" for="exampleRadio0" (click)="onExperienceValueChange(EXPERIENCE_ANY)">
                {{EXPERIENCE_ANY}}
              </label>
            </div>
            <div class="custom-form-check">
              <input class="form-check-input" formControlName="experienceType"
                [value]="EXPERIENCE_JUNIOR" style="display: none;" type="radio" id="exampleRadio1">
              <label class="form-check-label custom-radio-label  custom-text" for="exampleRadio1" (click)="onExperienceValueChange(EXPERIENCE_JUNIOR)">
                {{EXPERIENCE_JUNIOR}}
              </label>
            </div>
            <div class="custom-form-check">
              <input class="form-check-input" formControlName="experienceType"
                [value]="EXPERIENCE_MID_LEVEL" style="display: none;" type="radio" id="exampleRadio12">
              <label class="form-check-label custom-radio-label  custom-text" for="exampleRadio12" (click)="onExperienceValueChange(EXPERIENCE_MID_LEVEL)">
                {{EXPERIENCE_MID_LEVEL}}
              </label>
            </div>
            <div class="custom-form-check">
              <input class="form-check-input" formControlName="experienceType"
                [value]="EXPERIENCE_SENIOR" style="display: none;" type="radio" id="exampleRadio3">
              <label class="form-check-label custom-radio-label  custom-text" for="exampleRadio3" (click)="onExperienceValueChange(EXPERIENCE_SENIOR)">
                {{EXPERIENCE_SENIOR}}
              </label>
            </div>
            <div class="custom-form-check">
              <input class="form-check-input" formControlName="experienceType"
                [value]="EXPERIENCE_ARCHITECT" style="display: none;" type="radio" id="exampleRadio4">
              <label class="form-check-label custom-radio-label  custom-text" for="exampleRadio4" (click)="onExperienceValueChange(EXPERIENCE_ARCHITECT)">
                {{EXPERIENCE_ARCHITECT}}
              </label>
            </div>
          </div>
        </div>
        <div *ngIf="isLoading" class="load-overlay-filter" (click)="$event.stopPropagation();">
          <app-common-skeleton  [NameOftheScreen]="'CheckboxSelection'"></app-common-skeleton>
        </div>
    </mat-menu>



    <div class="dropdown-filter-input-container" [ngClass]="{'reduce-mr-rt': sourceCount > 0}" [matMenuTriggerFor]="menu3">
      <input formControlName="candidateSourceContent" placeholder="Candidate Source" type="text"
        class="form-control input-sm-1 dropdown-filter-input" yPosition="below" xPosition="after"
         [ngClass]="{'filter-selected-form-control candidate-source-ticker-space': sourceCount > 0}"
        id="candidateSource" readonly>
      <span *ngIf="sourceCount == 0" class="dropdown-filter-input-svg" >
        <ng-icon name="tablerChevronDown"></ng-icon>
      </span>
      <span *ngIf="sourceCount > 0" class="dropdown-filter-input-svg" >
        <ng-icon name="tablerChevronDown"></ng-icon>
      </span>
      <span *ngIf="sourceCount > 0" class="filter-count-ticker" >
        {{sourceCount}}
      </span>
    </div>
    <mat-menu #menu3="matMenu" [class]="'filter-body source-fit'">

      <section id="enabled2" class="filter-source-body" (click)="$event.stopPropagation();">
        <!-- Loading overlay lives INSIDE the position:relative section so its
             absolute veil sizes to the full option list. At the mat-menu level it
             only covered the panel's visible height, leaving the last rows
             (e.g. Business Network) un-veiled on a scrolling list. -->
        <div *ngIf="isLoading" class="source-scroll-loader" (click)="$event.stopPropagation();">
          <app-common-skeleton [NameOftheScreen]="'CheckboxSelection'"></app-common-skeleton>
        </div>
        <div class="col-sm-12" style="margin-bottom: 5px;">
          <div class="filter-title form-group" style="margin-bottom: 0;">
            <span class="card-header- tab-title custom-text"><b> Candidate Source</b></span>
          </div>
        </div>
        
        <!-- Content wrapper -->
        <div class="source-content-wrapper">
          <div formArrayName="source" [class.source-loading]="isLoading">
          <div *ngFor="let jobs of jobSourcesFormarray.controls; let i=index">
            <div [formGroupName]="i" >
              <div class="col-sm-12" >
                <div class="custom-checkbox" title="Search All filters">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" formControlName="all" (change)="jobSoucecheck($event,'all','horizontal')" />
                    <span class="checkmark" style="top: -5px"></span>
                    <p class="label-ppp"> All</p>
                  </label>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="custom-checkbox" title="Search All filters">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" formControlName="marketPlaceCandidates"
                      (change)="jobSoucecheck($event,'marketPlaceCandidates','horizontal')" />
                    <span class="checkmark" style="top: -5px"></span>
                    <p class="label-ppp"> Marketplace</p>
                  </label>
                </div>
              </div>

              <div class="col-sm-12" *ngIf="owner">
                <div class="custom-checkbox" title="Search My Candidates">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" formControlName="myCandidates"
                      (change)="jobSoucecheck($event,'myCandidates','horizontal')" />
                    <span class="checkmark" style="top: -5px"></span>
                    <p class="label-ppp"> {{ userType!='JOB_SEEKER' ? 'My Candidates' : 'My Profile'}}</p>
                  </label>
                </div>
              </div>

              <!-- <div class="col-sm-12" *ngIf="!filterApplied">
                <div class="custom-checkbox" title="Search Bench Candidates">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" formControlName="benchNetworkCandidates"
                      (change)="jobSoucecheck($event,'benchNetworkCandidates','horizontal')" />
                    <span class="checkmark" style="top: -5px"></span>
                    <p class="label-ppp"> Bench Sales Network</p>
                  </label>
                </div>
              </div>
              <div class="col-sm-12" *ngIf="!filterApplied">
                <div class="custom-checkbox" title="Search Freelancer Network">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" formControlName="freeLancerNetworkCandidates"
                      (change)="jobSoucecheck($event,'freeLancerNetworkCandidates','horizontal')" />
                    <span class="checkmark" style="top: -5px"></span>
                    <p class="label-ppp"> Freelancer Network</p>
                  </label>
                </div>
              </div>
              <div class="col-sm-12" *ngIf="!filterApplied">
                <div class="custom-checkbox" title="Search MTA Network">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" formControlName="mtaNetworkCandidates"
                      (change)="jobSoucecheck($event,'mtaNetworkCandidates','horizontal')" />
                    <span class="checkmark" style="top: -5px"></span>
                    <p class="label-ppp"> MTA Network</p>
                  </label>
                </div>
              </div>
              <div class="col-sm-12" *ngIf="!filterApplied">
                <div class="custom-checkbox" title="Search Job seeker Network">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" formControlName="jobSeekerNetworkCandidates"
                      (change)="jobSoucecheck($event,'jobSeekerNetworkCandidates','horizontal')" />
                    <span class="checkmark" style="top: -5px"></span>
                    <p class="label-ppp"> Job Seeker Network</p>
                  </label>
                </div>
              </div> -->

              <ng-container *ngIf="!filterApplied">
                <div class="col-sm-12" *ngFor="let filterItem of personalNetworks">
                  <div class="custom-checkbox">
                    <label class="checkbox-label font-normal">
                      <input type="checkbox" [formControlName]="filterItem?.key"
                        (change)="jobSoucecheck($event, filterItem?.key, 'personalNetworks')"/>
                      <span class="checkmark" style="top: -5px"></span>
                      <p class="label-ppp"> {{ filterItem?.networkName }}</p>
                    </label>
                  </div>
                </div>
              </ng-container>

              <!-- Job Seekers can't own or join a workspace -->
              <div class="col-sm-12" *ngIf="!filterApplied  && userType !='student' && userType !== 'JOB_SEEKER'">
                <div class="custom-checkbox" title="Search Workspace Candidates">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" formControlName="teamCandidates"
                      (change)="jobSoucecheck($event,'teamCandidates','horizontal')" />
                    <span class="checkmark" style="top: -5px"></span>
                    <p class="label-ppp"> Workspace Candidates</p>
                  </label>
                </div>
              </div>
              <div class="col-sm-12" >
                <div class="custom-checkbox" title="Search My Job">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" formControlName="memberNetworksCandidates"
                    (change)="jobSoucecheck($event,'memberNetworksCandidates')" />
                    <span class="checkmark" style="top: -5px"></span>
                    <p class="label-ppp"> Member Network</p>
                  </label>
                </div>
              </div>
              <div class="col-sm-12" *ngIf="userType != 'JOB_SEEKER' && businessNetworkData?.length > 0   ">
                <div class="custom-checkbox" title="Search My Job">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" formControlName="businessNetwork"
                    (change)="jobSoucecheck($event,'businessNetwork')" />
                    <span class="checkmark" style="top: -5px"></span>
                    <p class="label-ppp"> Business Network</p>
                  </label>
                </div>
              </div>
              <!-- <div class="col-sm-12" *ngIf="!FeaSugg && !filterApplied">
                <div class="custom-checkbox" title="Search Featured Candidates">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" formControlName="featured"
                      (change)="jobSoucecheck($event,'featured','horizontal')" />
                    <span class="checkmark" style="top: -5px"></span>
                    <p class="label-ppp"> Featured Candidates</p>
                  </label>
                </div>
              </div>
              <div class="col-sm-12" *ngIf="!FeaSugg && !filterApplied">
                <div class="custom-checkbox" title="Search Marketplace Candidates">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" formControlName="suggestedCandidates"
                      (change)="jobSoucecheck($event,'suggestedCandidates','horizontal')" />
                    <span class="checkmark" style="top: -5px"></span>
                    <p class="label-ppp"> Marketplace Candidates</p>
                  </label>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        </div>
      </section>
    </mat-menu>

    <div class="dropdown-filter-input-container"  [ngClass]="{'reduce-mr-rt': engagementTypeCount >0}" [matMenuTriggerFor]="menu4">
      <input formControlName="engagementTypeContent" placeholder="Engagement Type" type="text" readonly
        [ngClass]="{'filter-selected-form-control candidate-engagement-type-ticker-space': engagementTypeCount > 0}"
        class="form-control input-sm-1 dropdown-filter-input" yPosition="below" xPosition="after"
        id="engagementType">

      <span *ngIf="engagementTypeCount == 0" class="dropdown-filter-input-svg" >
        <ng-icon name="tablerChevronDown"></ng-icon>
      </span>
      <span *ngIf="engagementTypeCount > 0" class="dropdown-filter-input-svg" >
        <ng-icon name="tablerChevronDown"></ng-icon>
      </span>
      <span *ngIf="engagementTypeCount > 0" class="filter-count-ticker" >
        {{engagementTypeCount}}
      </span>
    </div>
    <mat-menu #menu4="matMenu" [class]="'filter-body flow-fit'">
      <div (click)="$event.stopPropagation();">

      <section (click)="onMenuItemClick($event)">

        <div class="col-sm-12">
          <div class="filter-title form-group" style="margin-bottom : 0;">
            <span class="card-header- tab-title custom-text"><b> Engagement Type</b></span>
          </div>
        </div>
        <div class="custom-checkbox  col-sm-12" title="{{checkbox.label}}"
          *ngFor="let checkbox of availableForCheckboxes;let i = index; let lastItem = last">
          <label class="checkbox-label font-normal">
            <input type="checkbox" [disabled]="checkbox.disable" name="trades" [checked]="checkbox.selected"
              (change)="availableCheckboxChange($event,checkbox.label,'horizontal')" />
            <span class="checkmark" style="top: -5px"></span>
            <p class="label-ppp"> {{ checkbox.label }}</p>
          </label>
        </div>
      </section>

      </div>
      <div *ngIf="isLoading" class="load-overlay-filter" (click)="$event.stopPropagation();">
        <app-common-skeleton  [NameOftheScreen]="'CheckboxSelection'"></app-common-skeleton>
      </div>
    </mat-menu>

    <div class="dropdown-filter-input-container" [ngClass]="{'reduce-mr-rt': workTypeCount > 0}"   [matMenuTriggerFor]="menu5">

      <input formControlName="workTypeContent" placeholder="Status" type="text" readonly
       [ngClass]="{'filter-selected-form-control add-workType-ticker-padding': workTypeCount > 0}"
       class="form-control input-sm-1 dropdown-filter-input" yPosition="below" xPosition="after"
       #worktype id="worktype">

       <span *ngIf="workTypeCount == 0" class="dropdown-filter-input-svg">
         <ng-icon name="tablerChevronDown"></ng-icon>
       </span>
       <span *ngIf="workTypeCount > 0" class="dropdown-filter-input-svg">
         <ng-icon name="tablerChevronDown"></ng-icon>
       </span>
       <span *ngIf="workTypeCount > 0" class="filter-count-ticker">
         {{workTypeCount}}
       </span>
     </div>
     <mat-menu #menu5="matMenu" [class]="'filter-body'">
      <div (click)="$event.stopPropagation();">
      <section (click)="onMenuItemClick($event)">
        <div class="col-sm-12">
          <div class="filter-title form-group"  style="margin-bottom: 0;">
            <span class="card-header- tab-title custom-text"><b> Work Mode</b></span>
          </div>
        </div>
        <div class="custom-checkbox  col-sm-12" title="{{checkbox.label}}"
          *ngFor="let checkbox of workModeCheckboxes ;let i = index; let lastItem = last">
          <label class="checkbox-label font-normal">
            <input type="checkbox" [disabled]="checkbox.disable" name="trades" [checked]="checkbox.selected"
              (change)="workModeChange($event.target.checked , checkbox?.label)" />
            <span class="checkmark" style="top: -5px"></span>
            <p class="label-ppp"> {{ checkbox.label }}</p>
          </label>
        </div>
      </section>

      </div>
      <div *ngIf="isLoading" class="load-overlay-filter" (click)="$event.stopPropagation();">
        <app-common-skeleton  [NameOftheScreen]="'CheckboxSelection'"></app-common-skeleton>
      </div>
    </mat-menu>  


    <div class="dropdown-filter-input-container" *ngIf="showWorkAuthorization" [matMenuTriggerFor]="menu6">
      <input placeholder="Work Authorization" type="text" class="form-control input-sm-1 dropdown-filter-input"
        yPosition="below" xPosition="after" id="workAuthorization">
      <span class="dropdown-filter-input-svg">
        <ng-icon name="tablerChevronDown"></ng-icon>
      </span>
    </div>
    <mat-menu #menu6="matMenu" [class]="'filter-body w-fit'">
      <div   (click)="$event.stopPropagation();">

      <section (click)="onMenuItemClick($event)">
        <div   *ngIf="showWorkAuthorization">
          <div class="col-sm-12">
            <div class="filter-title form-group"  style="margin-bottom: 0;">
              <span class="card-header- tab-title custom-text"><b> Work Authorization</b></span>
            </div>
          </div>
        </div>
        <div   *ngIf="showWorkAuthorization">
          <div class="custom-checkbox  col-sm-12" title="{{checkbox.label}}"
            *ngFor="let checkbox of WACheckboxes;let i = index; let lastItem = last">
            <label class="checkbox-label font-normal">
              <input type="checkbox" [disabled]="checkbox.disable" name="trades" [checked]="checkbox.selected"
                (change)="workAuthcheckbox($event,checkbox.label,'horizontal')" />
              <span class="checkmark" style="top: -5px"></span>
              <p class="label-ppp"> {{ checkbox.label }}</p>
            </label>
          </div>
        </div>
      </section>

      </div>
      <div *ngIf="isLoading" class="load-overlay-filter" (click)="$event.stopPropagation();">
        <app-common-skeleton  [NameOftheScreen]="'CheckboxSelection'"></app-common-skeleton>
      </div>
    </mat-menu>

    <div class="dropdown-filter-input-container" [ngClass]="{'reduce-mr-rt': availabilityCount > 0}" [matMenuTriggerFor]="menu7">
      <input formControlName="availabilityContent" placeholder="Availability" type="text"
        [ngClass]="{'filter-selected-form-control candidate-availability-ticker-space': availabilityCount > 0}"
        class="form-control input-sm-1 dropdown-filter-input" yPosition="below" xPosition="after"
       id="availability" readonly>
      <span *ngIf="availabilityCount == 0" class="dropdown-filter-input-svg">
        <ng-icon name="tablerChevronDown"></ng-icon>
      </span>
      <span *ngIf="availabilityCount > 0" class="dropdown-filter-input-svg">
        <ng-icon name="tablerChevronDown"></ng-icon>
      </span>
      <span *ngIf="availabilityCount > 0" class="filter-count-ticker">
        {{availabilityCount}}
      </span>
    </div>

    <mat-menu #menu7="matMenu" [class]="'filter-body'">
      <div  (click)="$event.stopPropagation();">
      <section (click)="onMenuItemClick($event)">
        <div class="col-sm-12">
          <div class="filter-title form-group"  style="margin-bottom: 0;">
            <span class="card-header- tab-title custom-text"><b> Availability</b></span>
          </div>
        </div>
        <div class="custom-checkbox  col-sm-12" title="{{checkbox.label}}"
          *ngFor="let checkbox of availablecheckbox;let i = index; let lastItem = last">
          <label class="checkbox-label font-normal">
            <input type="checkbox" [disabled]="checkbox.disable" name="trades" [checked]="checkbox.selected"
              (change)="availabletype($event,checkbox.label,'horizontal')" />
            <span class="checkmark" style="top: -5px"></span>
            <p class="label-ppp"> {{ checkbox.label }}</p>
          </label>
        </div>
      </section>
      </div>
      <div *ngIf="isLoading" class="load-overlay-filter" (click)="$event.stopPropagation();">
        <app-common-skeleton  [NameOftheScreen]="'CheckboxSelection'"></app-common-skeleton>
      </div>
    </mat-menu>


    <div class="dropdown-filter-input-container"  [ngClass]="{'reduce-mr-rt': statusCount > 1}" [matMenuTriggerFor]="menu8">
      <input formControlName="statusContent" placeholder="status" type="text"
      [ngClass]="{'filter-selected-form-control candidate-job-status-ticker-space': statusCount > 0}"
        class="form-control input-sm-1 dropdown-filter-input" yPosition="below" xPosition="after"
       id="status" readonly>
      <span *ngIf="statusCount == 0" class="dropdown-filter-input-svg">
        <ng-icon name="tablerChevronDown"></ng-icon>
      </span>
      <span *ngIf="statusCount > 0" class="dropdown-filter-input-svg">
        <ng-icon name="tablerChevronDown"></ng-icon>
      </span>
      <span *ngIf="statusCount > 0" class="filter-count-ticker">
        {{statusCount}}
      </span>
    </div>

    <mat-menu #menu8="matMenu" [class]="'filter-body'">
      <div  (click)="$event.stopPropagation();">
      <section (click)="onMenuItemClick($event)">
        <div class="col-sm-12">
          <div class="filter-title form-group"  style="margin-bottom: 0;">
            <span class="card-header- tab-title custom-text"><b> Status</b></span>
          </div>
        </div>
        <div [ngClass]="checkbox.disable ? 'hidden' : 'block'" class="custom-checkbox  col-sm-12" title="{{checkbox.label}}"
          *ngFor="let checkbox of statusCheckboxes ;let i = index; let lastItem = last">
          <label class="checkbox-label font-normal">
            <input type="checkbox"   name="trades" [checked]="checkbox.selected"
              (change)="statusChange($event.target.checked , checkbox?.label)" />
            <span class="checkmark" style="top: -5px"></span>
            <p class="label-ppp"> {{ checkbox.label }}</p>
          </label>
        </div>
      </section>

      </div>
      <div *ngIf="isLoading" class="load-overlay-filter" (click)="$event.stopPropagation();">
        <app-common-skeleton  [NameOftheScreen]="'CheckboxSelection'"></app-common-skeleton>
      </div>
    </mat-menu>


  </div>
  <div id="candidate_filter_scroll_right_button" (click)="scrollRight()" (mouseenter)="onMouseEnter1()" (mouseleave)="onMouseLeave1()"
    class="filter-show-hidden-design-right">
    <div class="right-scroll-buttons">
      <div>
        <ng-icon name="tablerChevronRight"></ng-icon>
      </div>
    </div>
  </div>
</ng-container>
